import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Startseite from './pages/Startseite';
import WartelisteFormular from './components/WartelisteFormular';
import KontaktFormular from './components/KontaktFormular';
import ProbetrainingFormular from './components/ProbetrainingFormular';
import AngeboteListe from './pages/AngeboteListe';
import AngebotFormular from './pages/AngebotFormular';
import GenericFormular from './pages/GenericFormular';
import PlatzangebotAntwort from './pages/PlatzangebotAntwort';
import './styles/widget.css';

function useIframeResize() {
  useEffect(() => {
    const sendHeight = () => {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({ type: 'swimdesk-resize', height }, '*');
    };

    sendHeight();

    const observer = new ResizeObserver(sendHeight);
    observer.observe(document.body);

    return () => observer.disconnect();
  }, []);
}

export default function App() {
  useIframeResize();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Startseite />} />
        <Route path="/warteliste" element={<WartelisteFormular />} />
        <Route path="/kontakt" element={<KontaktFormular />} />
        <Route path="/probetraining" element={<ProbetrainingFormular />} />
        <Route path="/angebote" element={<AngeboteListe />} />
        <Route path="/angebote/:id" element={<AngebotFormular />} />
        <Route path="/f/:key" element={<GenericFormular />} />
        <Route path="/antwort" element={<PlatzangebotAntwort />} />
      </Routes>
    </BrowserRouter>
  );
}
